import './SearchBox.scss';
import searchIcon from '../../../assets/icons/searchIcon.svg';

interface IProps {
  value: string;
  name: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeHolder?: string;
  maxLength: number;
}

const SearchBox = ({ value, name, onChange, placeHolder = '검색어 입력', maxLength }: IProps) => {
  return (
    <div className="searchBoxComponent">
      <input
        type="text"
        className="textLabel"
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeHolder}
        maxLength={maxLength}
      />
      <img src={searchIcon} alt="" className="searchIcon" />
    </div>
  );
};

export default SearchBox;
